class HeaderInlineSearch {
  constructor() {
    this.searchTrigger = document.getElementById('search-trigger-btn');
    this.searchInline = document.getElementById('header-search-inline');
    this.searchClose = document.getElementById('search-close-btn');
    this.searchInput = document.getElementById('Search-Inline');
    this.predictiveSearch = this.searchInline?.querySelector('predictive-search');
    
    this.init();
  }

  init() {
    if (!this.searchTrigger || !this.searchInline || !this.searchClose) return;

    // Event listeners
    this.searchTrigger.addEventListener('click', this.openSearch.bind(this));
    this.searchClose.addEventListener('click', this.closeSearch.bind(this));
    
    // Close search when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    
    // Handle escape key
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    
    // Handle search input focus and input
    if (this.searchInput) {
      this.searchInput.addEventListener('focus', this.handleInputFocus.bind(this));
      this.searchInput.addEventListener('input', this.handleInputChange.bind(this));
    }
  }

  openSearch() {
    this.searchInline.classList.add('active');
    this.searchTrigger.style.display = 'none';
    
    // Focus the input after a short delay to ensure the animation completes
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }, 100);
  }

  closeSearch() {
    this.searchInline.classList.remove('active');
    this.searchTrigger.style.display = 'flex';
    
    // Clear the input
    if (this.searchInput) {
      this.searchInput.value = '';
    }
    
    // Close predictive search if open
    if (this.predictiveSearch) {
      this.predictiveSearch.close(true);
    }
  }

  handleOutsideClick(event) {
    // Don't close if clicking inside the search area or on predictive search results
    if (this.searchInline?.contains(event.target) || 
        this.searchTrigger?.contains(event.target) ||
        event.target.closest('.predictive-search')) {
      return;
    }
    
    // Close if clicking outside and search is open
    if (this.searchInline?.classList.contains('active')) {
      this.closeSearch();
    }
  }

  handleKeydown(event) {
    // Close on escape key
    if (event.key === 'Escape' && this.searchInline?.classList.contains('active')) {
      this.closeSearch();
    }
  }

  handleInputFocus() {
    // Ensure predictive search opens when input is focused and has content
    if (this.predictiveSearch && this.searchInput.value.trim()) {
      // Trigger the predictive search if there's already a value
      setTimeout(() => {
        this.predictiveSearch.onFocus();
      }, 100);
    }
  }

  handleInputChange() {
    // Ensure predictive search updates when input changes
    if (this.predictiveSearch) {
      // Trigger the onChange method of predictive search
      setTimeout(() => {
        if (this.predictiveSearch.onChange) {
          this.predictiveSearch.onChange();
        }
      }, 100);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderInlineSearch();
});

// Also initialize if the script is loaded after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderInlineSearch();
  });
} else {
  new HeaderInlineSearch();
} 